module.exports = __webpack_public_path__ + "img/EvolveLab_Logo__Horizontal.c989ba95.png";